module.exports = __webpack_public_path__ + "static/img/图片.01f39d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/图片.png
// module id = 8Dmz
// module chunks = 16